/*
 * @Date: 2019-01-07 18:14:51
 * @LastEditors: zwj
 * @LastEditTime: 2022-12-14 18:26:19
 */

/**
 * 登录成功，把认证信息保存到localstorage，包括token，token过期时间，用户的unionId，username
 * @param{user}user
 */
 export function saveAuthInfo (authInfo) {
  authInfo.expiresTime = new Date().getTime() + parseInt(authInfo.expiresIn) * 1000
  localStorage.setItem('auth_info', JSON.stringify(authInfo))
  // localStorage.setItem('access_token', authInfo.accessToken)
  // localStorage.setItem('expires_time', new Date().getTime() + parseInt(authInfo.expiresIn) * 1000)
}

/**
 * 保存用户业务信息，例如名字，生日，性别等
 * @param {user}user
 */
export function saveUserBizInfo (userBiz) {
  localStorage.setItem('user_biz_info', JSON.stringify(userBiz))
}

/**
 * 保存用户权限列表
 * @param {user}user
 */
export function saveUserPermissions (permissions) {
  localStorage.setItem('permissions', JSON.stringify(permissions))
}

/**
 * 更新localstorage里面的token以及刷新过期时间
 * @param {token}token
 */
export function refreshTokenAndExpiresTime (tokenInfo) {
  // localStorage.removeItem('expires_time')
  localStorage.removeItem('auth_info')

  tokenInfo.expiresTime = new Date().getTime() + parseInt(tokenInfo.expiresIn) * 1000
  localStorage.setItem('auth_info', JSON.stringify(tokenInfo))
  // localStorage.setItem('expires_time', new Date().getTime() + parseInt(tokenInfo.expiresIn) * 1000)
  // localStorage.setItem('access_token', tokenInfo.accessToken)
}

/**
 * 获取用户权限列表
 */
export function getUserPermissions () {
  return JSON.parse(localStorage.getItem('permissions'))
}

/**
 * 获取用户认证信息，例如username unionId
 */
export function getAuthInfo () {
  return JSON.parse(localStorage.getItem('auth_info'))
}

/**
 * 获取用户业务信息
 */
export function getUserBizInfo () {
  return JSON.parse(localStorage.getItem('user_biz_info'))
}

/**
 * 退出登录，清除localstorage里面的用户信息和token信息
 */
export function removeUserInfo () {
  localStorage.clear()
}

/**
 * 获取token的到期时间戳
 */
export function getTokenExpiration () {
  let authInfo = JSON.parse(localStorage.getItem('auth_info'))
  return authInfo === null ? '' : authInfo.expiresTime
}

// 获取token
export function getAccessToken () {
  let authInfo = JSON.parse(localStorage.getItem('auth_info'))
  return authInfo === null ? '' : authInfo.accessToken
}

// 获取refresh_token
export function getRefreshToken () {
  let authInfo = JSON.parse(localStorage.getItem('auth_info'))
  return authInfo === null ? '' : authInfo.refreshToken
}

// 存取微信扫码state
export function saveWxState (state) {
	sessionStorage.setItem('wxState', state)
}
export function getWxState (state) {
	return	sessionStorage.getItem('wxState')
}

// 缓存绑定微信用户信息
export function saveWxBind (userInfo) {
	sessionStorage.setItem('wxBind', JSON.stringify(userInfo))
}
export function getWxBind (userInfo) {
	return	JSON.parse(sessionStorage.getItem('wxBind'))
}